import React from "react";
import { Space } from "@evercityecosystem/evercity-ui";
import dayjs from "dayjs";

const ProjectIdeaNoteCrumb = ({ createdDate }) => (
  <Space>{dayjs(createdDate).format("DD.MM.YYYY HH:mm")}</Space>
);

export default ProjectIdeaNoteCrumb;
